export default __webpack_public_path__ + "static/media/header.76c0a3ef.jpeg";